<template>
    <div id="startQuoteModal" ref="startQuoteModal" class="modal fade fxModal" data-bs-backdrop="static" tabindex="-1"
        aria-labelledby="startQuoteModalLabel" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered max-w-full tablet:!max-w-[90vw] largeDesktop:!max-w-[1200px] mobile:mx-[16px] tablet:mx-auto">
            <div class="modal-content">
                <div class="modal-body !p-[15px] font-roboto">
                    <FxModalHeader id="startQuoteModalLabel" :title="title" :dismiss="false"
                        @close="closeRQModal()" />
                    <!-- server-hosted create flow (orders/allow/create → init) -->
                    <iframe v-if="url" ref="frame" :src="url" :title="title"
                        class="w-full h-[75vh] border-0 rounded-[8px] mt-[15px]" />
                </div>
                <div class="modal-footer border-0 !px-[15px] !pt-0 !pb-[15px] flex items-center justify-between gap-2.5">
                    <p class="m-0 text-[13px] leading-[16px] text-[#666666] font-roboto">
                        Finish the quote in the form above. Close this window when you are done.
                    </p>
                    <button type="button" class="fxBtnSecondary" @click="closeRQModal()">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { useToast } from "vue-toastification";
import { rqApi } from "../../services/rqApi";

const toast = useToast();

export default {
    components: { FxModalHeader },
    emits: ['closed'],
    data() {
        return {
            url: '',
            title: 'Create Replacement Quote',
        };
    },
    mounted() {
        this.modal = new Modal(this.$refs.startQuoteModal);
        this.$refs.startQuoteModal.addEventListener('hidden.bs.modal', this.onHidden);
        window.addEventListener('message', this.onFrameMessage);
    },
    beforeUnmount() {
        window.removeEventListener('message', this.onFrameMessage);
        this.$refs.startQuoteModal?.removeEventListener('hidden.bs.modal', this.onHidden);
        this.modal?.dispose();
    },
    methods: {
        // title: System Designer opens the same server flow as "Create a new order" / "Your Summary"
        showModal(url, title = 'Create Replacement Quote') {
            this.url = url || '';
            this.title = title;
            disableScroll()
            this.modal.show();
        },
        closeRQModal() {
            this.modal.hide();
        },
        // Android WebViewFragment: "order-success" (order_id) → the new order's detail, "order-fail" → Oops dialog.
        // The single pager posts { redirect, url } to its parent (SystemCart.vue); only this iframe's messages count.
        async onFrameMessage(e) {
            const frame = this.$refs.frame;
            const redirect = e.data?.redirect;
            if (!frame || e.source !== frame.contentWindow || !['order-success', 'order-fail'].includes(redirect)) return;
            this.closeRQModal();
            if (redirect === 'order-fail') {
                this.$dialog.show({
                    title: 'Oops!',
                    text: 'Oops! Something Went Wrong. Please contact the fyxify Admin using Contact Us option and report this error. Thank you!',
                    buttonText: 'Ok',
                });
                return;
            }
            const id = await this.newOrderId(e.data);
            toast.success('The order has been placed successfully.');
            this.$router.push(id ? '/replacement-quote/detail/' + id : '/work-order/replacement-quote');
        },
        // order_id from the message (Laravel SystemCart, G-SP-16) or its url; an older build posts neither, then the
        // newest order in the technician's list is the one just created
        async newOrderId(data) {
            const fromMessage = Number(data.order_id) > 0 ? data.order_id : /[?&]order_id=(\d+)/.exec(data.url || '')?.[1];
            if (fromMessage) return fromMessage;
            const res = await rqApi.list({ page: 1, limit: 1, sort: { column: 'id', direction: 'DESC' } });
            return res.ok && Array.isArray(res.body) ? res.body[0]?.id : null;
        },
        // drop the iframe so the flow restarts next time, then let the list reload
        onHidden() {
            enableScroll()
            this.url = '';
            this.$emit('closed');
        },
    },
};
</script>
